<script>
import phonenumberRenderer from '@/views/components/renderers/phonenumber-renderer'

export default {
  components: {
    phonenumberRenderer
  },
  computed: {
    value() {
      return this.params.getValue();
    }
  }
};
</script>

<template>
  <phonenumber-renderer :value="value">
   
  </phonenumber-renderer>
</template>
